import React, { useState, Fragment, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from "@mui/material";
import * as constants from "../../../utils/Constants";

const CreateUsers = () => {
    let { state } = useLocation();
    let history = useHistory();
    if (!state) {
        state = {
            roles: "",
            userName: "",
            emailId: "",
        };
    }
    const [loginData, setLoginData] = useState({});
    const [isSpin, setIsSpin] = useState(false);
    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleBlur = (e) => {
        const newLoginData = { ...loginData };
        newLoginData[e.target.name] = e.target.value;
        setLoginData(newLoginData);
    };
    const submitHandler = (e) => {
        setIsSpin(true);
        if (loginData.userName || (loginData.emailId && loginData.password)) {
            var id = state.internalRecruiterId || state.adminId;
            var url = state.userName
                ? `${constants.UpdateUserUrl}/${state.id}`
                : constants.CreateUserUrl;
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${loggedInUser.sessionToken}`,
                },
                body: JSON.stringify(loginData),
            })
                .then((response) => response.json())
                .then((res) => {
                    if (res.message) {
                        if (res?.message?.messageCode) {
                            toast.success(`✅ ${res.message.messageDescription} !`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                            });
                            setTimeout(() => {
                                history.push("/list-user");
                            }, 3000);
                        }
                    } else if (res?.error) {
                        toast.error(`❌ ${res.error.errorMessage} !`, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        setIsSpin(false);
                    }
                });
        } else {
            toast.error(`❌ Please fill the required fields!`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setTimeout(() => {
                setIsSpin(false);
            }, 3000);
        }
    };
    const [input, setInput] = useState({
        roles: "",
        userName: "",
        emailId: "",
        employeeId: ""
    });
    const [error, setError] = useState({
        roles: "",
        userName: "",
        emailId: "",
        employeeId: ""
    });
    const onInputChange = (e) => {
        const { name, value } = e.target;
        const newLoginData = { ...loginData };
        newLoginData[e.target.name] = e.target.value;
        setLoginData(newLoginData);
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
        validateInput(e);
    };
    const validateInput = (e) => {
        let { name, value } = e.target;
        setError((prev) => {
            const stateObj = { ...prev, [name]: "" };
            switch (name) {
                case "userName":
                    if (!value) {
                        stateObj[name] = "Please Enter User Name.";
                    }
                    break;
                case "emailId":
                    if (!value) {
                        stateObj[name] = "Please Enter Email Id.";
                    }
                    if (value) {
                        stateObj[name] =
                            [/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/].every((pattern) =>
                                pattern.test(value)
                            ) || "Invalid Email Id";
                    }
                    break;
                case "employeeId":
                    if (!value) {
                        stateObj[name] = "Please Enter EmployeeId.";
                    }
                    break;
                default:
                    break;
            }
            return stateObj;
        });
    };
    return (
        <Fragment>
            <div className="row">
                <div className="col-xl-12 col-xxl-12">
                    <div className="row">
                        <div className="col-xl-12 col-lg-6">
                            <div className="card flex-lg-column flex-md-row ">
                                <div className="card-body card-body  text-center border-bottom profile-bx">
                                    <form
                                        action=""
                                        method="post"
                                        onSubmit={(e) => submitHandler(e)}
                                    >
                                        {!state.userName && (
                                            <div className="form-group row">
                                                <label
                                                    className="col-lg-4 col-form-label Description-Label"
                                                    htmlFor="val-website"
                                                >
                                                    User Type
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-4">
                                                    <select
                                                        name="roles"
                                                        onChange={handleBlur}
                                                        className="form-control Color-box"
                                                    >
                                                        <option value=" ">Please select</option>
                                                        <option value="Internal Recruiter">
                                                            Internal Recruiter
                                                        </option>
                                                        <option value="Admin">Admin</option>
                                                        <option value="Accountant">Accountant</option>
                                                        <option value="Key Account Manager">Key Accountant Manager</option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-group row">
                                            <label className="col-lg-4 col-form-label Description-Label">
                                                User Name
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="col-lg-4">
                                                <input
                                                    type="text"
                                                    // className="form-control Color-box"
                                                    className={
                                                        error.userName.length > 0
                                                            ? "is-invalid form-control"
                                                            : "form-control Color-box"
                                                    }
                                                    placeholder="Name"
                                                    defaultValue={state.userName}
                                                    name="userName"
                                                    onChange={onInputChange}
                                                    onBlur={validateInput}
                                                ></input>
                                                {error.userName && (
                                                    <span
                                                        style={{
                                                            color: "red",
                                                            fontSize: "13px",
                                                            marginLeft: "10px",
                                                        }}
                                                        className="err"
                                                    >
                                                        {error.userName}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        {!state?.userName && (
                                            <div className="form-group row">
                                                <label className="col-lg-4 col-form-label Description-Label">
                                                    Email
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-4">
                                                    <input
                                                        type="email"
                                                        defaultValue={state.emailId}
                                                        // className="form-control Color-box"
                                                        className={
                                                            error.emailId.length > 0
                                                                ? "is-invalid form-control"
                                                                : "form-control Color-box"
                                                        }
                                                        placeholder="Email"
                                                        name="emailId"
                                                        onChange={onInputChange}
                                                        onBlur={validateInput}
                                                    ></input>
                                                    {error.emailId && (
                                                        <span
                                                            style={{
                                                                color: "red",
                                                                fontSize: "13px",
                                                                marginLeft: "10px",
                                                            }}
                                                            className="err"
                                                        >
                                                            {error.emailId}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {!state?.userName && (
                                            <div className="form-group row">
                                                <label className="col-lg-4 col-form-label Description-Label">
                                                    Employee Id
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <div className="col-lg-4">
                                                    <input
                                                        type="text"
                                                        // className="form-control Color-box"
                                                        className={
                                                            error.employeeId.length > 0
                                                                ? "is-invalid form-control"
                                                                : "form-control Color-box"
                                                        }
                                                        placeholder="Employee Id"
                                                        defaultValue={state.employeeId}
                                                        name="employeeId"
                                                        // onChange={handleBlur}
                                                        onChange={onInputChange}
                                                        onBlur={validateInput}
                                                    ></input>
                                                    {error.employeeId && (
                                                        <span
                                                            style={{
                                                                color: "red",
                                                                fontSize: "13px",
                                                                marginLeft: "10px",
                                                            }}
                                                            className="err"
                                                        >
                                                            {error.employeeId}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="text-center mt-4">
                                            {isSpin ? (
                                                <button
                                                    type="button"
                                                    className="btn bg-white text-primary btn-block"
                                                >
                                                    <CircularProgress
                                                        color="inherit"
                                                        size={24}
                                                        sx={{
                                                            color: "green",
                                                        }}
                                                    />
                                                </button>
                                            ) : (
                                                <button
                                                    style={{
                                                        border: "none",
                                                        backgroundColor: "#00ADEE",
                                                        textAlign: "center",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary btn-md"
                                                    onClick={(e) => submitHandler(e)}
                                                >
                                                    {!state?.userName ? "Create User" : "Update User"}
                                                </button>
                                            )}
                                            <ToastContainer />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
export default CreateUsers;